export default __webpack_public_path__ + "static/media/si.d1897e94.svg";